import React from 'react';

export const UnCheckIcon = () => (
    <svg data-name="Component 170-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="Group_6548" data-name="Group 6548" transform="translate(-7.21 -7.2)">
            <path
                d="M17.21,7.2a10,10,0,1,1-10,10,10,10,0,0,1,10-10Z"
                transform="translate(0 0)"
                fill="#acb6c7"
                fill-rule="evenodd"
            />
        </g>
        <line
            y1="7"
            x2="7"
            transform="translate(6.501 6.499)"
            fill="none"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="2.2"
        />
        <path
            d="M0,7,2.625,4.375,7,0"
            transform="translate(6.501 13.499) rotate(-90)"
            fill="#243b5f"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="2.2"
        />
    </svg>
);
